import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { LogoutCallBackComponent } from './logout/logout-callback.component';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';

const routes: Routes = [
    { path: 'login', component: LoginComponent }, 
    { path: 'auth-callback', component: AuthCallbackComponent },
    { path: 'logout-callback', component: LogoutCallBackComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [],
  providers: []
})
export class AccountRoutingModule { }
